import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { renderError } from "../../helpers/errors";
import api from "../../services/api";

export const OrderPdf = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState(null);

    useEffect(() => {
        getPdf();
    }, []);

    const base64ToArrayBuffer = (base64) => {
        console.log(base64);
        const binary = window.atob(base64.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    };

    const getPdf = () => {
        setLoading(true);

        api.get(`/order/pdf/${id}`).then(res => {
            const { pdf, order } = res.data;
            const arrayBuffer = base64ToArrayBuffer(pdf);
            const file = new Blob([arrayBuffer], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            const name = order?.customer_company_trade_name ?? (order?.customer_name ?? 'Sem nome');
            link.download = `Pedido ${order.code} - ${name}.pdf`;
            link.click();
            setTimeout(() => {
                navigate(-1);
            }, 200);
        }).catch(error => {
            console.log(error);
            renderError(error);
        }).then(() => setLoading(false));
    }

    return (
        <>
            <Loading show={true} />
        </>
    );
}

export default OrderPdf;